import { ApiResponse, TokenData, IGovernorate } from '../models';
import * as http from './http';
import ApiService from './service';

export class GovernorateService extends ApiService {
  public async loadAllGovernorates(): Promise<IGovernorate[]> {
    const url = `${this.apiDomain}/api/Governorate/list`;
    const resposne = await http.get<ApiResponse<IGovernorate[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateGovernorate(data: IGovernorate, id?: string) {
    const url = `${this.apiDomain}/api/Governorate/${id}`;
    const response = await http.put<ApiResponse<IGovernorate>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createGovernorate(data: IGovernorate) {
    const url = `${this.apiDomain}/api/Governorate`;

    const response = await http.post<ApiResponse<IGovernorate>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteGovernorate(id?: string) {
    const url = `${this.apiDomain}/api/Governorate/${id}`;

    const response = await http.remove<ApiResponse<IGovernorate>>(
      url,
      this.store
    );
    return response.data;
  }
}
